import { render, staticRenderFns } from "./oldPunch.vue?vue&type=template&id=a822d9e6&scoped=true&"
import script from "./oldPunch.vue?vue&type=script&lang=js&"
export * from "./oldPunch.vue?vue&type=script&lang=js&"
import style0 from "./oldPunch.vue?vue&type=style&index=0&id=a822d9e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a822d9e6",
  null
  
)

export default component.exports